<msf-list-page-wrapper [leftSize]="'9'" [rightSize]="'3'" [rightBackground]="true">

  <div left #left>
    <div class="gis-page">
      <p-toast></p-toast>

      <div class="page-header">
        <h1 class="page-title">
          <app-back-button
            [title]="getRegionPathString()"
            parentRoute="/electronic-field-map"
          ></app-back-button>

        </h1>
      </div>

      <div class="map-wrapper">
        <div class="map-container"
             [class.map-season-cluster-theme]="filterModel.type === 'season'"
             [class.drawing-mode]="currentDrawingState.isDrawing && currentDrawingState.drawingType === 'polygon'">
          <div class="fields-summary-header">
            <span>{{ 'FIELDS_COUNT' | translate }}: <strong>{{ totalRecords() }}</strong></span>
          </div>
          <!-- OpenStreetMap Component -->
          <app-openstreetmap
            #openstreetmapComponent
            style="width: 100%;"
            [mapController$]="mapController$"
            [mapOptions]="mapOptions"
            (mapReady)="onMapReady()"
          ></app-openstreetmap>


          @if (panelOptions.crops) {
            <div class="map-monitoring-control">
              <button
                class="monitoring-btn"
                type="button"
                title="{{ 'CROP_IDENTIFICATION' | translate }}"
                (click)="showCropIdentificationPanel = true">
                <img src="assets/icons/main/light/electronic-fields.svg" width="40" height="40"
                     alt="{{ 'CROP_IDENTIFICATION' | translate }}">
              </button>
            </div>
          }

          @if (showCropIdentificationPanel) {
            <div class="crop-identification-panel" [ngStyle]="cropPanelStyle">
              <div class="crop-panel-header">
                <h3>{{ 'CROP_IDENTIFICATION' | translate }}</h3>
                <button class="close-btn" (click)="showCropIdentificationPanel = false">
                  <i class="pi pi-times"></i>
                </button>
              </div>
              <div class="crop-panel-content">
                @for (item of getCropIdentificationList(); track item.nameKey + item.kind) {
                  <div class="crop-item" [class.crop-item--map-status]="item.kind !== 'crop'">
                    @switch (item.kind) {
                      @case ('surveyBlocked') {
                        <div class="crop-color crop-color--survey-blocked" aria-hidden="true"></div>
                      }
                      @case ('planFactCorrespondence') {
                        <div
                          class="crop-color crop-color--plan-fact-stripes"
                          [ngStyle]="planFactLegendSwatchVars"
                          aria-hidden="true"
                        ></div>
                      }
                      @case ('planFactMismatch') {
                        <div class="crop-color crop-color--plan-fact-mismatch" aria-hidden="true"></div>
                      }
                      @default {
                        <div
                          class="crop-color"
                          [style.background-color]="item.color"
                          [style.border]="item.color === '#FFFFFF' || item.color === '#ffffff' ? '1px solid #e5e7eb' : 'none'"
                        ></div>
                      }
                    }
                    <span class="crop-name">{{ item.nameKey | translate }}</span>
                  </div>
                }
              </div>
            </div>
          }

        </div>
      </div>
    </div>
  </div>


  <div right #right>

    <app-import-field-modal
      [(visible)]="showImportModal"
    ></app-import-field-modal>

    @if (showWeatherModal && clickedLatLong.length > 0) {
      <app-point-polygon-details-modal
        [(visible)]="showWeatherModal"
        [latitude]="clickedLatLong[0]"
        [longitude]="clickedLatLong[1]"
        [regionPathString]="clickedObj?.name || (clickedObj?.names | translate)"
        [isOnlyInfo]="true"
      ></app-point-polygon-details-modal>
    }

    <msf-filters
      [fields]="filtersForms"
      [(ngModel)]="filterModel"
      (clearFilter)="clearFilters()"
      [metaData]="filterMetaData"
      (modelChange)="filterFieldsChange($event)"
      (applyFilter)="applyFilters()"
      [export]="true"
      (exportChange)="export()"
    ></msf-filters>

  </div>

  <!-- Field Details Modal -->
  <app-field-details-dialog
    (save)="loadMapData()"
  ></app-field-details-dialog>


  <app-season-details-dialog
    (save)="loadMapData()"
  ></app-season-details-dialog>


</msf-list-page-wrapper>

<app-export-dialog
  [(visible)]="showModalExport"
  [filtersParams]="filtersParams"
  [service]="exportService()"
  [exportMethod]="exportMethod()"
  [exportCsvMethod]="exportCsvMethod()"
></app-export-dialog>

